import { ReactNode } from "react";

interface LeadCardProps {
  children: ReactNode;
  highlight?: "amber" | "none";
  className?: string;
}

export default function LeadCard({ children, highlight = "none", className = "" }: LeadCardProps) {
  const ring =
    highlight === "amber"
      ? "border-amber-200 ring-2 ring-amber-100"
      : "border-secondary/10 hover:border-secondary/20";

  return (
    <div
      className={`group flex flex-col justify-between rounded-2xl border bg-white p-5 shadow-md transition-all duration-200 hover:-translate-y-0.5 hover:shadow-xl ${ring} ${className}`}
    >
      {children}
    </div>
  );
}
